<template>
  <v-flex class="subheading blue-grey--text text--darken-1">{{ name }}</v-flex>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  }
};
</script>